/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 2.34.976 on 2025-12-18 14:58:16.

export interface Courier {
  active: boolean;
  courierType: CourierType;
  creator: Receiver | null;
  destinationCity: string;
  destinationCitySlug: string | null;
  destinationCountry: string;
  destinationCountryCode: string | null;
  destinationType: string;
  details: string;
  expiresAt: Date;
  id: number | null;
  size: Size | null;
  sourceCity: string;
  sourceCitySlug: string | null;
  sourceCountry: string;
  sourceCountryCode: string | null;
  successfulDelivery: boolean | null;
}

export interface CourierFilterDto {
  active: boolean | null;
  courierType: CourierType | null;
  creatorName: string | null;
  destinationCity: string | null;
  destinationCountry: string | null;
  destinationType: string | null;
  size: number | null;
  sourceCity: string | null;
  sourceCountry: string | null;
}

export interface CourierMatchEmailDto {
  courierType: CourierType;
  creator: Receiver | null;
  destination: string;
  destinationType: string;
  details: string;
  size: Size | null;
  source: string;
}

export interface Grinch {
  active: boolean;
  comment: string;
  id: string;
}

export interface GrinchProjection {
  city: string;
  comment: string | null;
  country: string;
  id: string;
  isActive: boolean | null;
  name: string;
}

export interface HermesUser {
  city: string;
  country: string;
  email: string;
  enabled: boolean;
  id: string;
  name: string;
  password: string;
  pictureUrl: string;
  providerId: AuthProvider;
  roles: string[];
}

export interface HermesUserDto {
  city: string;
  email: string;
  id: string;
  name: string;
}

export interface InstructionsDto {
  collectingInstructions: string | null;
  deliveryInstructions: string | null;
}

export interface LockerInfoDto {
  cell: string;
  giverEmail: string;
  giverUpsa: string;
  location: string;
  recipientEmail: string;
  recipientUpsa: string;
}

export interface PackageTypeKt {
}

export interface Receiver {
  active: boolean;
  alternativeName: string;
  city: string;
  country: string;
  emails: string[];
  epamEmail: string;
  id: string;
  name: string;
  startDate: Date | null;
}

export interface ReceiverBase {
  alternativeName: string;
  id: string;
  name: string;
}

export interface ReceiverDto {
  city: string;
  emails: string[];
  epamEmail: string;
  id: string;
  name: string;
}

export interface ReceiverSearchRequestDto {
  searchString: string;
}

export interface ReceiverSearchResultDto {
  currentReceiver: number;
  match: boolean;
  potentialReceivers: Receiver[];
  searchString: string;
}

export interface Role {
  allRoles: string[];
}

export interface SantaFilterDto {
  locationName: string | null;
  locationOrEmpty: string;
  nameOrEmpty: string;
  santaName: string | null;
  statusName: string | null;
  statusOrEmpty: string;
}

export interface SecretSanta {
  deliveringLocker: SecretSantaLocker | null;
  deliveryStatus: SantaPresentDeliveryStatus;
  id: string;
  location: SecretSantaLocation;
  presentsCount: number;
  receiver: Receiver | null;
  receivingLocker: SecretSantaLocker | null;
  santa: Receiver;
  wishes: string | null;
}

export interface SecretSantaByReceiverDto {
  deliveryStatus: SantaPresentDeliveryStatus;
  id: string;
  locationId: number;
  locationName: string;
  lockerCell: string | null;
  lockerLocation: string | null;
  lockersSupported: boolean;
  presentCount: number | null;
  receiverId: string | null;
  receiverName: string | null;
  santaId: string | null;
  santaName: string | null;
  wishes: string | null;
}

export interface SecretSantaByReceiverProjection {
  deliveryStatus: SantaPresentDeliveryStatus | null;
  id: string;
  locationId: string;
  locationName: string;
  lockerCell: string | null;
  lockerLocation: string | null;
  lockersSupported: boolean;
  presentCount: number | null;
  receiverId: string;
  receiverName: string;
  santaId: string | null;
  santaName: string | null;
  wishes: string | null;
  isGrinch: boolean;
  grinchComment: string;
}

export interface SecretSantaDto {
  deliveringLocker: SecretSantaLockerDto | null;
  deliveryStatus: SantaPresentDeliveryStatus;
  location: SecretSantaLocationDto | null;
  presentsCount: number;
  readyToBeCollect: boolean;
  receiver: Receiver | null;
  receiverWishes: string;
  receivingLocker: SecretSantaLockerDto | null;
  santa: Receiver | null;
  santaState: number;
  santaWishes: string;
}

export interface SecretSantaHistory {
  deliveryStatus: SantaPresentDeliveryStatus;
  id: string;
  location: string;
  presentsCount: number;
  receiver: Receiver | null;
  santa: Receiver;
  wishes: string | null;
  year: number;
}

export interface SecretSantaLocation {
  active: boolean;
  collectingInstructions: string;
  deliveryInstructions: string;
  id: number | null;
  lockersSupported: boolean;
  name: string;
  reindeerIds: string[];
  santaState: number;
}

export interface SecretSantaLocationBaseProjection {
  id: number;
  name: string;
}

export interface SecretSantaLocationDto {
  collectingInstructions: string;
  deliveryInstructions: string;
  id: number;
  name: string;
}

export interface SecretSantaLocationFull {
  active: boolean;
  collectingInstructions: string;
  collectingInstructionsCompiled: string;
  deliveryInstructions: string;
  deliveryInstructionsCompiled: string;
  exactAddress: string | null;
  id: number;
  lockersSupported: boolean;
  name: string;
  reindeers: string | null;
  santaState: number;
  santasCount: string;
  santasCountByStatus: string;
}

export interface SecretSantaLocationHistoryProjection {
  name: string;
  santasCount: number;
  year: number;
}

export interface SecretSantaLocationProjection {
  collectingInstructions: string;
  deliveryInstructions: string;
  exactAddress: string | null;
  id: number;
  isActive: boolean;
  lockersSupported: boolean;
  name: string;
  reindeers: string | null;
  santaState: number;
  santasCount: string;
  santasCountByStatus: string;
}

export interface SecretSantaLocker {
  cell: string;
  delivered: boolean;
  location: string;
  receiverId: string;
  santaId: string;
}

export interface SecretSantaLockerDto {
  cell: string;
  location: string;
}

export interface SecretSantaLockerProjection {
  exact_address: string;
  receiver_id: string;
  santa_id: string;
}

export interface SentEmailsChartData {
  anniversaryCount: number[];
  courierMatchCount: number[];
  dates: string[];
  insuranceCardPackagesCount: number[];
  regularPackagesCount: number[];
  remindersCount: number[];
  secretSantaParticipantsPackagesCount: number[];
  secretSantaPresentPackagesCount: number[];
  secretSantaRegistrationPackagesCount: number[];
  softLandingPackagesCount: number[];
  telegramRegistrationCount: number[];
}

export interface SentLetterHistoryLog {
  date: Date;
  id: number | null;
  receiver: Receiver;
  reminderSent: boolean;
  sender: HermesUser;
  status: NotificationStatus;
  type: PackageType;
}

export interface SentLetterHistoryLogDto {
  date: Date;
  id: number;
  receiver: ReceiverDto;
  reminderSent: boolean;
  sender: HermesUserDto;
  status: NotificationStatus;
  type: PackageType;
}

export interface Setting {
  id: string;
  intValue: number;
}

export interface Size {
  id: number | null;
  name: string | null;
  size: number | null;
}

export interface TelegramDto {
  chatId: number | null;
  userName: string | null;
}

export interface TelegramUser {
  code: string | null;
  id: number;
  lastCodeGenerated: Date | null;
  receiver: Receiver | null;
  tgUserName: string | null;
  verified: boolean;
}

export interface UiReceiverBase {
  alternative: boolean;
  baseName: string;
  id: string;
  name: string;
}

export interface UserLogin {
  date: Date;
  id: number;
  user: HermesUser;
}

export interface VersionResponse {
  version: string;
}

export interface Wishes {
  wishes: string;
}

export type AuthProvider = "hermes" | "github" | "epam";

export type CourierType = "COURIER" | "SENDER";

export type NotificationStatus = "NOTIFICATION_SENT" | "COLLECTED";

export type PackageType = "REGULAR" | "SOFTLANDING" | "INSURANCE_CARD" | "SANTA_REGISTRATION" | "SANTA_PARTICIPATION" | "SANTA_PRESENT" | "SANTA_FEEDBACK" | "TELEGRAM_REGISTRATION" | "COURIER_MATCH" | "ANNIVERSARY_MESSAGE" | "REMINDER";


export const SantaPresentDeliveryStatuses = [
  "NOT_DELIVERED",
  "MARKED_AS_DELIVERED",
  "DELIVERY_CONFIRMED",
  "DELIVERY_DOUBLE_CHECKED",
  "NOTIFICATION_SENT",
] as const;

export type SantaPresentDeliveryStatus = typeof SantaPresentDeliveryStatuses[number];
